import { createAction } from '@reduxjs/toolkit';
export const SYSTEM_RESUME = 'SYSTEM_RESUME';
export const systemResumeAction = createAction(SYSTEM_RESUME);